import React, { useEffect } from 'react';
import { showErrorToast } from '@fff-web/fff-ui-shared/Toast';
import styles from './Timer.module.scss';
import useTimer from './useTimer';

type Props = {
  viewSize: string,
  expDate: Date,
};

const Timer = (props: Props) => {
  const { expDate, viewSize } = props;
  const { minutes, seconds, timeUp } = useTimer(expDate);
  useEffect(() => {
    if (timeUp) {
      showErrorToast(
        <div style={{ textAlign: 'left' }}>Timer Has Expired</div> as unknown as string, // hacky. oof.
        'Your choices are not guaranteed at this point.',
      );
    }
  }, [timeUp]);

  return (
    <div className={`${styles.timer} ${styles[viewSize]}`}>
      <div className={`${styles.box} ${styles.minutes}`}>
        {minutes}
        m
      </div>
      <span>:</span>
      <div className={`${styles.box} ${styles.seconds}`}>
        {seconds}
        s
      </div>
    </div>
  );
};

export default Timer;
